document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll(".footer-banner-cta-block").forEach((el) => {
        const element = el.querySelector(".footer-banner-cta-block__content");
        const elementPicture = el.querySelector(".wp-block-cover__image-background");

        const ctaPageFooter = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: "top bottom",
                end: "bottom 80%",
                scrub: true
            },
        });

        gsap.set(element, { opacity: 0, y: 100 });

        ctaPageFooter.to(
            element, {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: "power1.inOut"                
            }
        );

        ctaPageFooter.to(
            elementPicture, {
                scale: 1.1,
                duration: 1,
                ease: "power1.inOut"                
            },
            '='
        );
    });
});